import type { ResponseMessage } from '@kiddocare-platform/portal-common/base'
import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import type { Medicine } from '@kiddocare-platform/portal-common/family'
import { isCacheValid } from '../../../entry.cache'
import type { FamilyCacheState } from '../types'

const addMedicines: CaseReducer<
  FamilyCacheState,
  PayloadAction<ResponseMessage<Array<Medicine>>>
> = (state, action) => {
  state.medicines = { value: action.payload, cachedAt: Date.now() }
}

const removeMedicines: CaseReducer<FamilyCacheState, PayloadAction<void>> = (state) => {
  state.medicines = undefined
}

const purgeExpiredMedicinesCache: CaseReducer<FamilyCacheState> = (state) => {
  if (!isCacheValid(state.medicines)) {
    state.medicines = undefined
  }
}

export const medicinesReducers = {
  addMedicines,
  removeMedicines,
  purgeExpiredMedicinesCache,
}
